<template>
  <div>
    <b-modal
      id="link_medicine"
      title="VINCULAR MEDICAMENTO"
      hide-footer
      no-close-on-backdrop
      size="lg"
    >
      <div class="row">
        <div class="col-md-12">
          <input
            type="text"
            class="form-control"
            v-model="search"
            @input="listMedicines"
          />
        </div>
        <div class="col-md-12" style="height: 400px; overflow-y: scroll">
          <div v-for="(item, key) in medicines" :key="key" class="pt-1 pb-1">
            <div class="row m-0 v-clean">
              <div class="col-md-8">
                <h6 class="mb-0">
                  NOME:
                  {{ item.name }}
                </h6>
                <div class="mb-0">
                  UNIDADE DE MEDIDA:
                  {{ item.unit_of_measurement_name }}
                </div>
                <div class="mb-0">
                  TIPO:
                  {{ item.type == "PADRAO" ? "PADRÃO" : "EMPRESA" }}
                </div>
              </div>
              <div
                class="col-md-4 d-flex align-items-center jutify-content-center"
              >
                <v-btn class="btn-edit" @click="selectItem(item)"
                  ><i class="fas fa-check mr-2"></i>SELECIONAR</v-btn
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-form @submit.prevent="evOnSubmit">
      <b-row>
        <b-col class="pt-0 pb-0">
          <label-required-field label="NOME" />
          <b-input :disabled="isSelectedtItem" ref="autofocus" v-model="name" />
        </b-col>
      </b-row>
      <div class="row">
        <div
          v-if="!isSelectedtItem"
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0"
        >
          <SelectActiveIngredientID
            :disabled="isSelectedtItem"
            v-model="active_ingredient_id"
          />
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 pt-0 pb-0">
          <label>LISTA</label>
          <select
            :disabled="isSelectedtItem"
            v-model="list"
            class="form-control"
          >
            <option value>SELECIONE...</option>
            <option v-for="value in lists" :key="value.id" :value="value.name">
              {{ String(value.name).toUpperCase() }}
            </option>
          </select>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 pt-0 pb-0">
          <label>TIPO DE RECEITA</label>
          <select
            :disabled="isSelectedtItem"
            v-model="type_of_recipe_id"
            class="form-control"
          >
            <option value>SELECIONE...</option>
            <option
              v-for="value in typesOfRecipe"
              :key="value.id"
              :value="value.id"
            >
              {{ String(value.name).toUpperCase() }}
            </option>
          </select>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 pt-0 pb-0">
          <LabelRequiredField label="UNIDADE DE MEDIDA" />
          <select
            :disabled="isSelectedtItem"
            v-model="unit_of_measurement_id"
            class="form-control"
            @change="handleChangeUnitOfMeasurementId($event.target.value)"
          >
            <option value="">SELECIONE...</option>
            <option
              v-for="value in standardUnitOfMeasurement"
              :key="value.id"
              :value="value.id"
            >
              {{ value.name }}
            </option>
          </select>
        </div>
        <div class="col-xl-8 col-lg-8 col-md-6 col-sm-6 col-12 pt-0 pb-0">
          <label>CLASSE TERAPÊUTICA</label>
          <input
            :disabled="isSelectedtItem"
            type="text"
            v-model="therapeutic_class"
            class="form-control"
          />
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 pt-0 pb-0">
          <label>TIPO DE MEDICAMENTO</label>
          <select
            :disabled="isSelectedtItem"
            v-model="type_of_medicine_id"
            class="form-control"
          >
            <option value>SELECIONE...</option>
            <option
              v-for="value in typesOfMedicine"
              :key="value.id"
              :value="value.id"
            >
              {{ String(value.name).toUpperCase() }}
            </option>
          </select>
        </div>
      </div>
      <b-row>
        <b-col>
          <label-required-field label="CATEGORIA" />
          <b-select
            :options="categories"
            text-field="name"
            value-field="id"
            v-model="stock_item_category_id"
          ></b-select>
        </b-col>
        <b-col>
          <label-required-field label="TAMANHO" />
          <b-input v-model.number="size"></b-input>
        </b-col>
      </b-row>
      <errors-messages :errors="errors" />
      <b-row align-h="between">
        <b-col cols="auto">
          <v-btn-cancel @click="$bvModal.hide('new_medicine')" />
        </b-col>
        <b-col cols="auto">
          <v-btn-save :disabled="loading" :loading="loading" type="submit" />
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import ErrorsMessages from "../ErrorsMessages.vue";
import LabelRequiredField from "../LabelRequiredField.vue";
import VBtnCancel from "../VBtnCancel.vue";
import VBtnSave from "../VBtnSave.vue";
import SelectActiveIngredientID from "../SelectActiveIngredientID.vue";

import api from "../../../services/api";

import toast from "../../../lib/ToastNotification";

export default {
  name: "NewMedicine",

  components: {
    VBtnSave,
    VBtnCancel,
    LabelRequiredField,
    ErrorsMessages,
    SelectActiveIngredientID,
  },

  props: {
    stock_item_categories: Array,
    stock_item_units_of_measurement: Array,
    standardUnitOfMeasurement: Array,
    active_ingredient: Array,
    typesOfMedicine: Array,
    typesOfRecipe: Array,
    defaultName: { type: String, default: "" },
  },

  data() {
    return {
      search: "",

      errors: [],
      loading: false,
      loadingMedicines: false,

      isSelectedtItem: false,
      selectedtItem: false,

      medicines: [],

      value_active_ingredient_id: "",
      active_ingredient_id: "",
      list: "",
      type_of_recipe_id: "",
      unit_of_measurement_id: "",
      therapeutic_class: "",
      type_of_medicine_id: "",

      name: "",
      stock_item_category_id: "",
      stock_item_unit_of_measurement_id: "",
      size: "",

      lists: [
        { id: 1, name: "A1" },
        { id: 2, name: "A2" },
        { id: 3, name: "A3" },
        { id: 4, name: "B1" },
        { id: 5, name: "C1" },
        { id: 6, name: "C5" },
        { id: 7, name: "D1" },
      ],
    };
  },

  created() {
    this.isSelectedtItem = false;
    this.selectedtItem = false;

    this.listMedicines();
    this.evOnShow();
    this.evOnShown();
  },

  computed: {
    categories() {
      return [{ id: "", name: "SELECIONE" }, ...this.stock_item_categories];
    },

    unitOfMeasurement() {
      return [
        { id: "", name: "SELECIONE" },
        ...this.stock_item_units_of_measurement,
      ];
    },
  },

  methods: {
    handleChangeUnitOfMeasurementId(id) {
      if (id) {
        let { standardUnitOfMeasurement, stock_item_units_of_measurement } =
          this;

        let unit = standardUnitOfMeasurement.find((item) => item.id == id);

        if (unit) {
          let unit_of_measurement = stock_item_units_of_measurement.find(
            ({ value }) => unit.value == value
          );

          if (unit_of_measurement) {
            this.stock_item_unit_of_measurement_id = unit_of_measurement.id;
          }
        }
      } else {
        this.stock_item_unit_of_measurement_id = "";
      }
    },

    selectItem(item) {
      this.isSelectedtItem = true;
      this.selectedtItem = item;

      let { unitOfMeasurement } = this;

      this.name = item.name;
      this.active_ingredient_id = item.active_ingredient_id;
      this.type_of_recipe_id = item.type_of_recipe_id;
      this.unit_of_measurement_id = item.unit_of_measurement_id;
      this.therapeutic_class = item.therapeutic_class;
      this.type_of_medicine_id = item.type_of_medicine_id;
      this.list = item.list;

      let unit_of_measurement = unitOfMeasurement.find(
        ({ abbreviation }) =>
          item.unit_of_measurement_abbreviation == abbreviation
      );

      if (unit_of_measurement) {
        this.stock_item_unit_of_measurement_id = unit_of_measurement.id;
      }

      this.$bvModal.hide("link_medicine");
    },

    handleModalLink() {
      this.$bvModal.show("link_medicine");
    },

    handleUnLinkItem() {
      this.isSelectedtItem = false;
      this.selectedtItem = false;
      this.name = "";
      this.active_ingredient_id = "";
      this.type_of_recipe_id = "";
      this.unit_of_measurement_id = "";
      this.therapeutic_class = "";
      this.type_of_medicine_id = "";
      this.list = "";
      this.stock_item_unit_of_measurement_id = "";
    },

    async listMedicines() {
      try {
        this.loadingMedicines = true;

        const params = { search: this.search };

        const response = await api.get(
          "/rest-home/medicine/list-not-linked-stock-item",
          {
            params,
          }
        );

        const { error, errors, data } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.medicines = data;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingMedicines = false;
      }
    },

    async evOnShow() {
      this.errors = [];
      this.loading = false;

      this.stock_item_category_id = "";
      this.stock_item_unit_of_measurement_id = "";
      this.name = this.defaultName;
      this.size = "";
    },

    async evOnShown() {
      setTimeout(() => this.$refs.autofocus.focus(), 200);
    },

    async evOnSubmit() {
      try {
        this.loading = true;

        let {
          name,
          stock_item_category_id,
          size,
          stock_item_unit_of_measurement_id,
          selectedtItem,
          active_ingredient_id,
          type_of_recipe_id,
          unit_of_measurement_id,
          therapeutic_class,
          type_of_medicine_id,
          list,
        } = this;

        const params = {
          name,
          stock_item_unit_of_measurement_id,
          stock_item_category_id,
          size,
          selectedtItem,
          active_ingredient_id,
          type_of_recipe_id,
          unit_of_measurement_id,
          therapeutic_class,
          type_of_medicine_id,
          list,
        };

        const response = await api.post(
          "/rest-home/stock/items/medicine",
          params
        );

        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.$bvModal.hide("new_medicine");
          toast(message, "success");
          this.$emit("created");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
</style>